// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2H2V8H22V2ZM7.33057 10H2V22H7.33057V10ZM14.6655 10H9.33496V22H14.6655V10ZM16.6689 10H21.9995V22H16.6689V10Z","fillRule":"evenodd","clipRule":"evenodd"}}]};

const Table1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'table-1-filled',
    ref,
    icon: element,
  },
));

Table1FilledIcon.displayName = 'Table1FilledIcon';

export default Table1FilledIcon;
